export enum EmailTemplate {
  WaitlistOpened = '13bcc189-b15b-466d-9efd-c5ff6769540a',
  WaitlistClosed = '6948e62a-7025-4a23-a19a-d6afcc6fbc0e',
  Invited = '3950ec67-379e-4c66-aa1a-9e996d220ba3',
  InviteAccepted = '5b523c67-0142-4b31-9750-349dd92c5398',
  InviteCancelled = '5aa376d3-bd2e-49f2-a4ee-90788b56e8b6',
  InviteRejected = '6cec76c6-a683-4206-bcb8-ef9b425c04bd',
  InviteChanged = '0387b43a-df9e-4243-8379-ea2684d9c7d4',
  InviteExpired = 'fc0bcbb0-7270-48d0-94d5-cd0a4c53f025',
  PartnerCanceled = 'b097afd6-52cc-4f04-823c-1baccaa43f28',
  BaitABuddy = '67292044-bb65-44b8-b4e8-1bf69fc47fae',
  FirstTimeSignin = '523328fd-718e-4743-81b7-f391e85586d8',
  TrailAboutToExpire = '4c592576-430b-4de3-be1a-51558d6f36fa',
  WalkinMemberInviteToFitbeat = 'a8ca1f28-dc40-493d-a227-84a8bbc27be8', // unused, kept for reference
  FirstDemerit = '6d4d5f6b-4b14-4a7a-85e2-ea1224fa8bde',
  DemeritCausingPenalisation = '50257df1-da54-45c4-8b56-60041b54074b',
  PasswordChanged = 'edfe7bb1-65ec-4536-b4a2-3adb6fb4aa3f',
  PlanCancelled = '02ed213f-68a5-4352-ab6d-26af8d16c040',
  PaymentFailed = 'ddfb5a42-39e0-4140-bfc4-2f4208e59086',
  AccountCancelled = '140d149f-aee8-4bfe-9875-5e7d7be2681d',
  PlanChanged = 'f188cd1d-311a-4c83-9273-0a24abe581ae',
  ReviewLastWorkout = '94b67d39-b19d-4d82-b951-7d4d41658173',
  AppStoreLinks = '0276c9c9-532b-41a5-9e39-3e5423ce2c94',
  FamilyPlanInvite = 'c227e397-0451-47ba-bbc1-df76de35ca81',
  StudioOnboardingCompleted = '14df4c31-5305-41d7-9eab-c332846aecf4',
  HomeOnboardingCompleted = '4f77f5be-5d81-42bc-b132-bf01aa968d83',
  StudioCheckInReminder = '8435726b-bcf2-465a-bbb5-c1898a10b97b',
  HomeCheckInReminder = 'd35d6d2a-1c84-4e1f-a5f2-774ed89f313e',
  AccountCreated = '131fb563-c8f2-43ff-9bc8-a213417a8284',
  StudioFirstWorkoutBooked = 'e7d1f8a7-2016-49db-914d-c3d4db91c300',
  HomeFirstWorkoutBooked = '8a28257b-1527-4b27-9da2-29501943a5ca',
  PostFirstWorkout = '2decf1bb-52f1-44df-abd8-4650772adbd5',
  PostSecondWorkout = '18e0457a-c4b7-4ac0-9192-9a62bc07e2af',
}
